export const toastColors = {
  error: "bg-destructive text-destructive-foreground",
  default: "border border-border bg-background text-foreground",
};
